import { useState, type Dispatch, type SetStateAction } from 'react';
import type { MarketplaceListing, MarketplaceRate } from '../../models/apiTypes';
import { useTonConnect } from '../../hooks/useTonConnect';

export interface UseMarketplaceBuyResult {
  buyListing: MarketplaceListing | null;
  setBuyListing: Dispatch<SetStateAction<MarketplaceListing | null>>;
  buyRate: MarketplaceRate | null;
  setBuyRate: Dispatch<SetStateAction<MarketplaceRate | null>>;
  setBuyLoading: Dispatch<SetStateAction<boolean>>;
  buyCurrency: 'ton' | 'usdt';
  setBuyCurrency: Dispatch<SetStateAction<'ton' | 'usdt'>>;
  buyWalletLoading: boolean;
  setBuyWalletLoading: Dispatch<SetStateAction<boolean>>;
  showManualPayment: boolean;
  setShowManualPayment: Dispatch<SetStateAction<boolean>>;
  walletConnected: boolean;
  sendTon: ReturnType<typeof useTonConnect>['sendTon'];
  sendUsdt: ReturnType<typeof useTonConnect>['sendUsdt'];
  connectWallet: ReturnType<typeof useTonConnect>['connectWallet'];
}

export function useMarketplaceBuy(): UseMarketplaceBuyResult {
  const [buyListing, setBuyListing] = useState<MarketplaceListing | null>(null);
  const [buyRate, setBuyRate] = useState<MarketplaceRate | null>(null);
  const [, setBuyLoading] = useState(true);
  const [buyCurrency, setBuyCurrency] = useState<'ton' | 'usdt'>('ton');
  const [buyWalletLoading, setBuyWalletLoading] = useState(false);
  const [showManualPayment, setShowManualPayment] = useState(false);
  const { connected: walletConnected, sendTon, sendUsdt, connectWallet } = useTonConnect();

  return {
    buyListing,
    setBuyListing,
    buyRate,
    setBuyRate,
    setBuyLoading,
    buyCurrency,
    setBuyCurrency,
    buyWalletLoading,
    setBuyWalletLoading,
    showManualPayment,
    setShowManualPayment,
    walletConnected,
    sendTon,
    sendUsdt,
    connectWallet,
  };
}
